window.onload = function()
{
  var $ = jQuery;


  
  ////// HERO BANNER & FULL SCREEN //////
  // this is required because Facebook browser will readjust the viewheight on scroll, causing layout shifts
  var viewHeight;
  var previousWidth=0;
  var navHeight;
  var herocolumns;
  var scrollHook;
  var fullscreens;

  var headerAlphaColor = 'rgb(1, 1, 1)';
  var alpha = 1;


  function setHeight(){
    if(previousWidth != $(window).width()){
      previousWidth = $(window).width();
      viewHeight = $(window).height();
      
      headerAlphaColor = $('#headerBG').css('backgroundColor'); 
      if (headerAlphaColor != null){   
        alpha = (isNaN(parseFloat(headerAlphaColor.split(',')[3]))) ? 1 : parseFloat(headerAlphaColor.split(',')[3]); //parseFloat(headerAlphaColor.split(',')[3]);
      } else {alpha=1;}
      
      if($("header").length > 0 && $("header").is(':visible') && alpha > 0) {
        navHeight = $("header").outerHeight();
      } else {navHeight = 0;}
      if($("#announcementBar").length > 0  && $("#announcementBar").is(':visible')) {
        navHeight += $("#announcementBar").outerHeight();
      }
      if(scrollHook.length > 0){$("#scrollHook").css('cssText', 'top: -' + (navHeight + 20) +'px!important');}
      if(herocolumns.length > 0){$(".herocolumn").css('cssText', 'height:' + (viewHeight - navHeight) +'px!important');}
      if(fullscreens.length > 0){$(".heightFullscreen").css('cssText', 'min-height:' + (viewHeight - navHeight) +'px!important');}
      $("#menu-drawer").css('cssText', 'padding-top:' + (60 + navHeight) +'px!important');
    }
    if (videoAccordion) //make sure to reset these when screen-resolution changes
    {videoAccordion[0].parentElement.parentElement.style.minHeight = videoAccordion[0].scrollHeight+"px";}
    if (imageAccordion)
    {imageAccordion[0].parentElement.style.minHeight = imageAccordion[0].scrollHeight+"px";}
  }

  function FirstRunHeight(){
    herocolumns = $(".herocolumn");
    fullscreens = $(".heightFullscreen");
    scrollHook = $("#scrollHook")
    if(herocolumns.length > 0 || fullscreens.length > 0 || scrollHook.length > 0) {
      setHeight();
      window.addEventListener("resize", setHeight);
    }
  }
  FirstRunHeight();
  
  //need this interval check, otherwise the height does not autocorrect in Customizer prior to reloading the page
  if (Shopify.designMode) {
    var intervalId = window.setInterval(function(){
      setHeight();
    }, 1000);
  }
  

  
  ////// MENU CODE //////
  var selectMenu;
  var selectMenuchildren;
  
  function defocusElements() {
    $(this).children('.selectitem').addClass('defocused');
  }
  
  function refocusElements() {
    $(this).children('.selectitem').removeClass('defocused');
  }

  function expandtags() {
    if($(this).children('.chevron').hasClass('_rotate')){
      $(this).children('.chevron').removeClass('_rotate');
      $('#tagnavigator').removeClass('flexWrap');
      $('#tagnavigator').addClass('overrideScrollable_X');
    }
    else{
      $(this).children('.chevron').addClass('_rotate');
      $('#tagnavigator').removeClass('overrideScrollable_X');
      $('#tagnavigator').addClass('flexWrap');
    }
    
  }

  function setupMenu() {
    selectMenu = document.getElementsByClassName("selectmenu");
    chevron = document.getElementById("tagchevron");
    for (var i = 0; i < selectMenu.length; ++i) {
      selectMenuchildren = selectMenu[i].children;
      if(selectMenuchildren.length > 1){
        selectMenu[i].removeEventListener("mouseenter", defocusElements, false);
        selectMenu[i].addEventListener("mouseenter", defocusElements, false);
        selectMenu[i].removeEventListener("mouseleave", refocusElements, false);
        selectMenu[i].addEventListener("mouseleave", refocusElements, false);
      }
    };
    if(chevron != null)
    {
      chevron.removeEventListener("click", expandtags, false);
      chevron.addEventListener("click", expandtags, false);
    }
    /*
    for (var i = 0; i < chevron.length; ++i) {
      chevronchildren = chevron[i].children;
      if(chevronchildren.length > 0){
        chevron[i].removeEventListener("click", expandtags, false);
        chevron[i].addEventListener("click", expandtags, false);
      }
    };
    */
  }
  setupMenu();

  //need this interval check, otherwise the menu does not work after generated in Customizer prior to reloading the page
  if (Shopify.designMode) {
    var intervalId = window.setInterval(function(){
      setupMenu();
    }, 1000);
  }
  
  

  ////// LIGHTBOX CODE //////
  var galleryImages;
  var galleryLightbox;
  var galleryLightboxImages;
  var galleryClose;
  var galleryLeft;
  var galleryRight;
  var currentImage;
  //var dataPhoto;

  function galleryimageClick() {
    //$('#galleryLightboxJQ').show();
    $('#galleryLightboxJQ').removeClass('_transitionOut');
    $('#galleryLightboxJQ').addClass('_galleryShow');
    
    //dataPhoto = $(this).attr('src');
    //$('#galleryLightboxImageJQ').attr("src", dataPhoto);
    
    $('header').hide();
    $('#announcementBar').hide();
    $("html, body").css("overflow","hidden");
    
    if(galleryLightboxImages.length > 0){
      for(var i=0; i<galleryLightboxImages.length; ++i){
        galleryLightboxImages[i].setAttribute('src', galleryImages[i].dataset.src); //galleryImages[i].getAttribute('src'));
      }
    }
    currentImage = $(this).data('imageindex');
    galleryLightboxImages[currentImage].parentElement.classList.add('_imageShow');
    if (galleryLightboxImages[currentImage].nodeName == 'SOURCE'){
      galleryLightboxImages[currentImage].parentElement.load();
      galleryLightboxImages[currentImage].parentElement.play();
    }
  }

  function gobackLightbox(){
    galleryLightboxImages[currentImage].parentElement.classList.remove('_imageShow');
    if (galleryLightboxImages[currentImage].nodeName == 'SOURCE'){
      galleryLightboxImages[currentImage].parentElement.pause();
    }
    currentImage -= 1;
    if(currentImage < 0){
      currentImage = galleryLightboxImages.length - 1;
    }
    galleryLightboxImages[currentImage].parentElement.classList.add('_imageShow');
    if (galleryLightboxImages[currentImage].nodeName == 'SOURCE'){
      galleryLightboxImages[currentImage].parentElement.load();
      galleryLightboxImages[currentImage].parentElement.play();
    }
    //dataPhoto = galleryImages[currentImage].getAttribute('src');
    //$('#galleryLightboxImageJQ').attr("src", dataPhoto);
  }

  function goforwardLightbox(){
    galleryLightboxImages[currentImage].parentElement.classList.remove('_imageShow');
    if (galleryLightboxImages[currentImage].nodeName == 'SOURCE'){
      galleryLightboxImages[currentImage].parentElement.pause();
    }
    currentImage += 1;
    if(currentImage >= galleryLightboxImages.length){
      currentImage = 0;
    }
    galleryLightboxImages[currentImage].parentElement.classList.add('_imageShow');
    if (galleryLightboxImages[currentImage].nodeName == 'SOURCE'){
      galleryLightboxImages[currentImage].parentElement.load();
      galleryLightboxImages[currentImage].parentElement.play();
    }
    //dataPhoto = galleryImages[currentImage].getAttribute('src');
    //$('#galleryLightboxImageJQ').attr("src", dataPhoto);
  }

  function closeLightbox(){
    galleryLightboxImages[currentImage].parentElement.classList.remove('_imageShow');
    if (galleryLightboxImages[currentImage].nodeName == 'SOURCE'){
      galleryLightboxImages[currentImage].parentElement.pause();
    }
    
    //$('#galleryLightboxJQ').hide();
    $('#galleryLightboxJQ').addClass('_transitionOut');
    $('#galleryLightboxJQ').removeClass('_galleryShow');
    $('header').show();
    $('#announcementBar').show();
    $("html, body").css("overflow","initial");
  }
  
  function setupLightbox() {
    galleryImages = document.getElementsByClassName("galleryimageJQ");
    
    if(galleryImages.length > 0){
      galleryLightboxImages = document.getElementsByClassName("galleryLightboxImageJQ");
      galleryLightbox = document.getElementById("galleryLightboxJQ");
      galleryClose = document.getElementById("galleryClose");
      galleryLeft = document.getElementById("galleryNav_left");
      galleryRight = document.getElementById("galleryNav_right");
      
      for (var i = 0; i < galleryImages.length; ++i) {
        galleryImages[i].removeEventListener("click", galleryimageClick, false);
        galleryImages[i].addEventListener("click", galleryimageClick, false);
      };
      galleryClose.removeEventListener("click", closeLightbox, false);
      galleryClose.addEventListener("click", closeLightbox, false);
      galleryLeft.removeEventListener("click", gobackLightbox, false);
      galleryLeft.addEventListener("click", gobackLightbox, false);
      galleryRight.removeEventListener("click", goforwardLightbox, false);
      galleryRight.addEventListener("click", goforwardLightbox, false);
    }
  }
  setupLightbox();

  //need this interval check, otherwise the lightbox does not work after generated in Customizer prior to reloading the page
  if (Shopify.designMode) {
    var intervalId = window.setInterval(function(){
      setupLightbox();
    }, 1000);
  }

  
  
  ////// ACCORDION CODE //////
  var accordions;
  var flag_bgBlock = false;

  var flag_enableSubheadings = false;
  var targetSubheading;

  var dataAccordionImage;
  var imageAccordion;
  var dataAccordionVideo;
  var videoAccordion;

  function accordionClick() {
    // this allows multiple accordions to co-exist on the same page
    flag_bgBlock = $(this).parent().hasClass("backgroundBlockJQ");
    flag_enableSubheadings = $(this).parent().hasClass("enableSubheadingsJQ");

    if(!$(this).hasClass('_active')){
      if(!$(this).hasClass('staysOpen')){
        $(this).siblings('.accordionJQ').removeClass('_active'); 
        $(this).siblings('.accordionJQ').addClass('defocused'); 
        if(!flag_enableSubheadings){
          $(this).siblings('.accordionJQ').children('.chevron').removeClass('_rotate'); 
          $(this).siblings('.accordiontextDisplay').removeClass('_textShow'); 
          $(this).siblings('hr').removeClass('_dividerShow');
        }
        else{
          var position = $(this).index();
          $('#subheadingContent').children().eq(position).siblings().addClass('_subheadingHidden');
          $('#subheadingContent').children().eq(position).removeClass('_subheadingHidden');
        }
      }
      
      if(!flag_enableSubheadings){   
        $(this.nextElementSibling).addClass('_dividerShow');
        $(this.nextElementSibling.nextElementSibling).addClass('_textShow'); 
      }

      $(this).addClass('_active');
      $(this).removeClass('defocused');
      if(!flag_enableSubheadings){
        $(this).children('.chevron').addClass('_rotate');
      }

      // image replacement
      if($(this).hasClass('accordionJQImage')){
        dataAccordionImage = $(this).data('image');
        if (flag_bgBlock){
          imageAccordion =  $(this).parent().parent().parent().next().children('div').children('img');
          imageAccordion[0].parentElement.parentElement.style.minHeight = imageAccordion[0].parentElement.parentElement.scrollHeight+"px";
        }
        else{
          imageAccordion =  $(this).parent().parent().parent().next().children('img');
          imageAccordion[0].parentElement.style.minHeight = imageAccordion[0].parentElement.scrollHeight+"px";
        }
        imageAccordion[0].attr("src", dataAccordionImage);
      }
      // video replacement
      if($(this).hasClass('accordionJQVideo')){
        dataAccordionVideo = $(this).data('video');
        if (flag_bgBlock){
          videoAccordion = $(this).parent().parent().parent().next().children('div').children('.videoContainer').children('video');
          videoAccordion[0].parentElement.parentElement.parentElement.style.minHeight = videoAccordion[0].parentElement.parentElement.parentElement.scrollHeight+"px"; 
        }
        else {
          videoAccordion = $(this).parent().parent().parent().next().children('.videoContainer').children('video');
          videoAccordion[0].parentElement.parentElement.style.minHeight = videoAccordion[0].parentElement.parentElement.scrollHeight+"px";
        }
        videoAccordion[0].src = dataAccordionVideo;
        videoAccordion[0].load;
        videoAccordion[0].play;
      }
    }
    else{
      $(this).removeClass('_active');
      $(this).addClass('defocused');  
      if(!flag_enableSubheadings){
        $(this).children('.chevron').removeClass('_rotate'); 
        $(this.nextElementSibling.nextElementSibling).removeClass('_textShow'); 
        $(this.nextElementSibling).removeClass('_dividerShow');
      }
    };
  }

  function setupAccordions() {
    accordions = document.getElementsByClassName("accordionJQ");
    
    if(accordions.length > 0){
      for (var i = 0; i < accordions.length; ++i) {
        accordions[i].removeEventListener("click", accordionClick, false);
        accordions[i].addEventListener("click", accordionClick, false);
      };
    }
  }
  setupAccordions();

  //need this interval check, otherwise the accordion does not work after generated in Customizer prior to reloading the page
  if (Shopify.designMode) {
    var intervalId = window.setInterval(function(){
      setupAccordions();
    }, 1000);
  }



  ////// IMAGE SLIDER CODE //////
  
  //SIMPLE SLIDER CODE
  /*
  var slideshow = $(".imageSlideshow");
  
  if(slideshow.length > 0) {
    $(".imageSlideshow > div:gt(0)").hide();
    
    setInterval(function() { 
      $('.imageSlideshow > div:first')
        .fadeOut(1000)
        .next()
        .fadeIn(1000)
        .end()
        .appendTo('.imageSlideshow');
    },  2500);
  }
  */

  /*
  //this works but requires jQuery Min, not slim
  
  var slideshow;
  var slideImages;
  var fadeout;
  var fadein;
  function showFirstSlide()
  {
    for(var i=0;i<slideImages.length;++i){
      slideImages[i].style.display = "none";
      slideImages[i].style.opacity = 0;
    }
    slideImages[0].style.display = "block";
    slideImages[0].style.opacity = 1;
  }
  function nextSliderImage()
  {
    fadeout = document.querySelector(".imageSlideshow div:first-child");
    fadeout.style.display = "block";
    fadeout.style.opacity = 1;
    fadein = document.querySelector(".imageSlideshow div:nth-child(2)");
    fadein.style.display = "block";
    fadein.style.opacity = 0;
  }

  var lastTime_slider;
  var delta_slider;
  function playSliderAnimation(time_slider) {
    if(lastTime_slider != null){
      delta_slider = time_slider - lastTime_slider;
      fadeout.style.opacity = parseFloat(fadeout.style.opacity) - delta_slider * 0.001;
      fadein.style.opacity = parseFloat(fadein.style.opacity) + delta_slider * 0.001;
  
      if (parseFloat(fadein.style.opacity) >= 2.5) {
        fadeout.style.display = "none";
        document.querySelector('.imageSlideshow').append(fadeout);
        nextSliderImage();
      }
    }

    lastTime_slider = time_slider;
    window.requestAnimationFrame(playSliderAnimation);
  }
  function setupSlider()
  {
    slideImages = document.querySelectorAll(".imageSlideshow > div");
    showFirstSlide();
    nextSliderImage();
  }
  var slideAnimation;
  function initiateSlideAnimation(){
    slideshow = document.querySelector(".imageSlideshow");
    if(slideshow != null) {
      setupSlider();
      if(slideAnimation != null) {cancelAnimationFrame(slideAnimation);}
      slideAnimation = window.requestAnimationFrame(playSliderAnimation);
    }
  }
  initiateSlideAnimation();

  window.addEventListener("resize", initiateSlideAnimation);
  */

  var $imagecarousel;
  var $BGwrapper;
  var allImages;
  var imagewidth=0;
  var previousWidth_slider=0;

  var isMobile = window.innerWidth < 640;

  function check_ifBG()
  {
    $BGwrapper = $('#bgSlideshow');   
    if($BGwrapper.children().length > 0)
    {
      var sectionHeight = $BGwrapper.parent().height();
      $BGwrapper.css('height', sectionHeight);
      $BGwrapper.children("#imageList").children().each(function () {
          $(this).css('height', sectionHeight);
          $(this).css('width', '100vw');
      });
    }
  }

  function setWrapperWidth_images()
  {
    imagewidth=0;
    $imagecarousel = $('#imageList');
    allImages = $imagecarousel.children().length;
    if(allImages > 0)
    {
      //$imagecarousel.show(); // slide images are hidden until page is fully loaded
      for(var i=0; i<allImages; ++i){
        imagewidth += $('#imageList li').eq(i).width();
      }
      
      $imagecarousel.css('width', imagewidth);
      if($imagecarousel.hasClass('mobileOnlySlider') && isMobile){ 
        $imagecarousel.css('left', -(imagewidth / allImages)+( (window.innerWidth-(imagewidth / allImages)) /2)+"px");
      }
    }
  }

  var firstImage;
  var firstImageWidth;
  function nextSlideImage()
  {
      firstImage = document.querySelector("#imageList li:first-child");
      firstImageWidth = firstImage.offsetWidth;
  }

  var lastTime_image = 0;
  var timeSinceTransition;
  var TransitionInitiated = false;
  function playImageSlideAnimation(time_image) {
    timeSinceTransition = time_image - lastTime_image;
    if(!TransitionInitiated && timeSinceTransition > 4000)
    {
      if(!$imagecarousel.hasClass('mobileOnlySlider') || $imagecarousel.hasClass('mobileOnlySlider') && isMobile){ //pass through the slide animation if slider is set to be mobile-only
        firstImage.style.marginLeft = -firstImageWidth + 'px';
      }
      TransitionInitiated = true;
    }
    if(TransitionInitiated && timeSinceTransition > 4500)
    {
      lastTime_image = time_image;
      TransitionInitiated = false;
      if(!$imagecarousel.hasClass('mobileOnlySlider') || $imagecarousel.hasClass('mobileOnlySlider') && isMobile){ //pass through the slide animation if slider is set to be mobile-only
        firstImage.style.marginLeft = 0 + 'px';
        document.querySelector('#imageList').append(firstImage);
      }
      nextSlideImage();
    }
    
    window.requestAnimationFrame(playImageSlideAnimation);
  }
  var imageAnimation;
  function initiateImageAnimation(){
    check_ifBG();
    isMobile = window.innerWidth < 640;
    if(previousWidth_slider != $(window).width()){
      previousWidth_slider = $(window).width();
      setWrapperWidth_images();
    }
    if(allImages > 0) {
      nextSlideImage();
      if(imageAnimation != null) {cancelAnimationFrame(imageAnimation);}
      imageAnimation = window.requestAnimationFrame(playImageSlideAnimation);
      
      window.addEventListener("resize", initiateImageAnimation);
    }
  }
  initiateImageAnimation();

  //need this interval check, otherwise the accordion does not work after generated in Customizer prior to reloading the page
  if (Shopify.designMode) {
    var intervalId = window.setInterval(function(){
      initiateImageAnimation();
    }, 4500);
  }


  
  //LOGO SLIDER CODE
  // http://stackoverflow.com/questions/6759494/jquery-function-definition-in-a-carousel-script
  // https://blog.webdevsimplified.com/2021-12/request-animation-frame/

  //initial setup
  var $logocarousel;
  var allLogos;
  var logowidth=0;

  function setWrapperWidth_logos()
  {
    logowidth=0;
    $logocarousel = $('#logosList');
    allLogos = $logocarousel.children().length;
    if(allLogos > 0)
    {
      //$logocarousel.show(); // logos are hidden until page is fully loaded
      for(var i=0; i<allLogos; ++i){
        logowidth += $('#logosList li').eq(i).width();
      }
      
      $logocarousel.css('width', logowidth);
    }
  }

  var first;
  var firstWidth;
  function nextLogoImage()
  {
      first = document.querySelector("#logosList li:first-child");
      firstWidth = first.offsetWidth;
  }

  var lastTime_logo;
  var delta_logo;
  function playLogoAnimation(time_logo) {
    if (lastTime_logo != null) {
      delta_logo = time_logo - lastTime_logo;
      first.style.marginLeft = Math.round(parseFloat(first.style.marginLeft) - delta_logo * 0.07) + 'px';
  
      if (parseFloat(first.style.marginLeft) <= -firstWidth) {
        first.style.marginLeft = 0;
        document.querySelector('#logosList').append(first);
        nextLogoImage();
      }
    }

    lastTime_logo = time_logo;
    window.requestAnimationFrame(playLogoAnimation);
  }
  
  var logoAnimation;
  var previousWidth_Logos=0;

  function initiateLogoAnimation(){
    if(previousWidth_Logos != $(window).width()){
      previousWidth_Logos = $(window).width();
      setWrapperWidth_logos();
      if(allLogos > 0) {
        nextLogoImage();
        if(logoAnimation != null) {cancelAnimationFrame(logoAnimation);}
        logoAnimation = window.requestAnimationFrame(playLogoAnimation);
      }
    }
  }
  
  function FirstRunLogos(){
    initiateLogoAnimation();
    if(allLogos > 0) {
      window.addEventListener("resize", initiateLogoAnimation);
    }
  }
  FirstRunLogos();

  //var rotating = true;
  /*$(document).on({
    mouseenter: function() {
      rotating = false; // turn off rotation when hovering
    },
    mouseleave: function() {
      rotating = true;
    }
  }, '#logos');*/
  
  //need this interval check, otherwise the slider does not work after generated in Customizer prior to reloading the page
  if (Shopify.designMode) {
    var intervalId = window.setInterval(function(){
      initiateLogoAnimation();
    }, 1000);
  }

  
}
